import { useTranslation } from 'react-i18next'

import { HandbagIcon } from '@phosphor-icons/react'

import AnimatedNumber from '@/common/components/AnimatedNumber/AnimatedNumber'
import { statisticStatuses } from '@/common/components/Statistic/constants'
import Statistic from '@/common/components/Statistic/Statistic'

const EarningsFromUpSells = ({ earningsFromUpSells, currency }) => {
  const { t } = useTranslation()

  return (
    <Statistic
      size="small"
      isOutlined={false}
      status={statisticStatuses.success}
      Icon={HandbagIcon}
      label={t('Ingresos por ventas extra')}
      value={<AnimatedNumber target={earningsFromUpSells} format="currency" currency={currency} />}
    />
  )
}

export default EarningsFromUpSells
